import { ButtonLoader } from "../loaders/loaders";

const ButtonWithLoader = ({
  text,
  children,
  onClick,
  isLoading,
  disabled = false,
  className = "",
  type,
  fillStroke,
}) => (
  <button
    type={type || "button"}
    className={`${className} ${disabled ? "disabled" : ""}`}
    disabled={disabled}
    onClick={isLoading || disabled ? undefined : onClick}
  >
    {isLoading ? <ButtonLoader fillStroke={fillStroke} /> : text || children}
  </button>
);

export default ButtonWithLoader;
